import React, { useEffect } from "react";

const ConsentModal = ({ isOpen, onAccept, onDeny }) => {
    useEffect(() => {
        const consentModal = document.getElementById('consent-modal');
        if (consentModal) {

            const consentGiven = localStorage.getItem('consentGiven');
            if (consentGiven === null) {
                document.getElementById('consent-modal-overlay').style.display = 'block';
                document.getElementById('consent-modal').style.display = 'block';
            } else {
                document.getElementById('consent-modal-overlay').style.display = 'none';
                document.getElementById('consent-modal').style.display = 'none';
            }
        }    
        
        return () => {
            closeConsentModal();
        };
        
    }, []);

    const handleAccept = () => {
        window.gtag('consent', 'update', {
            'ad_storage': 'granted',
            'analytics_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted'
        });
        onAccept();
        localStorage.setItem('consentGiven', 'true');
        closeConsentModal();
    };

    const handleDeny = () => {
        window.gtag('consent', 'update', {
            'ad_storage': 'denied',
            'analytics_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied'
        });
        onDeny();
        localStorage.setItem('consentGiven', 'false');
        closeConsentModal();
    };

    const closeConsentModal = () => {
        const consentModal = document.getElementById('consent-modal');
        if (consentModal) {
            document.getElementById('consent-modal-overlay').style.display = 'none';
            document.getElementById('consent-modal').style.display = 'none';
        }
    }

    return (
        <>
            <div id="consent-modal-overlay" className={`consent-modal-overlay ${isOpen ? 'show' : 'hide'}`}></div>
            <div id="consent-modal" className={`consent-modal ${isOpen ? 'show' : 'hide'}`}>
                <div className="consent-modal-content">
                    <i className="fas fa-cookie-bite"></i>
                    <h2>Consentimento de Cookies</h2>
                    <p>Utilizamos cookies para melhorar sua experiência. Por favor, forneça seu consentimento para o uso de cookies.</p>
                    <div className="button-container">
                        <button className="accept" onClick={handleAccept}>Aceitar</button>
                        <button className="deny" onClick={handleDeny}>Negar</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConsentModal;